export default "__VITE_PUBLIC_ASSET__d1cbbfe2__"